// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-page__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.25rem;
}

.data-page__intro h2 {
  margin: 0 0 0.35rem;
  font-size: clamp(1.6rem, 4vw, 2.2rem);
  font-weight: 700;
}

.data-page__subtitle {
  margin: 0 0 1.5rem;
  color: var(--color-text-muted);
  font-size: 0.95rem;
}

.data-page__intro:has(.data-page__error) .data-page__subtitle,
.data-page__intro:has(.data-page__message) .data-page__subtitle {
  margin-bottom: 0.5rem;
}

.data-page__import-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  flex-shrink: 0;
  padding: 0.75rem 1.1rem;
  border: none;
  border-radius: var(--radius);
  background: var(--color-btn);
  color: var(--color-btn-text);
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: filter 0.2s ease, background 0.2s ease;
}

.data-page__import-btn:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-hover);
}

.data-page__import-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.data-page__import-btn svg,
.data-page__bulk-btn svg,
.data-page__action-btn svg {
  color: var(--color-icon);
}

.data-page__import-btn svg {
  width: 16px;
  height: 16px;
}

.data-page__bulk-btn svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.data-page__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: data-page-spin 0.7s linear infinite;
}

@keyframes data-page-spin {
  to {
    transform: rotate(360deg);
  }
}

.data-page__table-section {
  margin-top: 1.5rem;
}

.data-page__table-toolbar {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.data-page__search {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  width: 100%;
  padding: 0.85rem 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  color: var(--color-text);
  font: inherit;
}

.data-page__search:focus-within {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px var(--color-accent-soft);
}

.data-page__search-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  color: var(--color-text-muted);
  line-height: 1;
}

.data-page__search-icon svg,
.data-page__search-icon .app-icon {
  width: 18px;
  height: 18px;
  color: var(--color-text-muted);
}

.data-page__search input {
  flex: 1 1;
  min-width: 0;
  width: auto;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  color: var(--color-text);
  font: inherit;
  line-height: 1.2;
  outline: none;
  appearance: none;
}

.data-page__search input::-webkit-search-decoration,
.data-page__search input::-webkit-search-cancel-button {
  appearance: none;
}

.data-page__search input::placeholder {
  color: var(--color-text-muted);
}

.data-page__bulk-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.data-page__feedback {
  margin-bottom: 0.75rem;
}

.data-page__error {
  margin: 0 0 1.5rem;
  color: var(--color-secondary);
  font-size: 0.9rem;
  font-weight: 600;
}

.data-page__intro .data-page__message {
  margin: 0 0 1.5rem;
}

.data-page__bulk-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.55rem 0.9rem;
  border: none;
  border-radius: var(--radius);
  background: var(--color-btn);
  color: var(--color-btn-text);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  cursor: pointer;
  transition: filter 0.2s ease, background 0.2s ease;
}

.data-page__bulk-btn--delete {
  background: var(--color-btn-danger);
  color: var(--color-btn-text);
}

.data-page__bulk-btn--delete:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-danger-hover);
}

.data-page__bulk-btn:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-hover);
}

.data-page__bulk-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.data-page__bulk-btn--import:hover:not(:disabled),
.data-page__bulk-btn--add:hover:not(:disabled) {
  color: var(--color-btn-text);
}

.data-page__modal--confirm h3 {
  margin-bottom: 0.75rem;
}

.data-page__confirm-message {
  margin: 0 0 0.5rem;
  color: var(--color-text);
  font-size: 0.95rem;
}

.data-page__confirm-detail {
  margin: 0 0 1rem;
  color: var(--color-text-muted);
  font-size: 0.88rem;
}

.data-page__modal-btn--danger {
  background: var(--color-btn-danger);
  color: var(--color-btn-text);
}

.data-page__modal-btn--danger:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-danger-hover);
}

.data-page__modal-btn--danger:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.data-page__table-wrap {
  overflow-x: auto;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
}

.data-page__rdt {
  --rdt-color-bg: var(--color-surface-raised);
  --rdt-color-header-bg: var(--color-surface);
  --rdt-color-text-primary: var(--color-text);
  --rdt-color-divider: var(--color-border);
  --rdt-color-highlight: var(--color-rdt-highlight);
  --rdt-color-highlight-text: var(--color-text);
  --rdt-color-selected: var(--color-accent-soft);
  --rdt-color-striped: var(--color-rdt-striped);
  --rdt-color-btn-hover: var(--color-rdt-btn-hover);
  --rdt-color-scrollbar-thumb-hover: var(--color-rdt-scrollbar-hover);
}

.data-page__rdt .rdt_rowHighlight:hover,
.data-page__rdt .rdt_TableRow:hover {
  background-color: var(--color-rdt-highlight) !important;
  color: var(--color-text) !important;
}

.data-page__rdt .rdt_rowHighlight:hover .rdt_TableCell,
.data-page__rdt .rdt_rowHighlight:hover .rdt_cell,
.data-page__rdt .rdt_TableRow:hover .rdt_TableCell {
  color: var(--color-text) !important;
}

.data-page__rdt .rdt_Pagination button {
  color: var(--color-text);
  fill: var(--color-text);
}

.data-page__rdt .rdt_Pagination button:disabled {
  opacity: 0.45;
}

.data-page__rdt .rdt_Pagination select,
.data-page__rdt .rdt_Pagination svg {
  color: var(--color-text-muted);
  fill: var(--color-text-muted);
}

.data-page__rdt .rdt_TableCol_Sortable,
.data-page__rdt .rdt_TableCell {
  color: var(--color-text);
}

.data-page__rdt input[type='checkbox'] {
  accent-color: var(--color-accent);
  cursor: pointer;
}

.data-page__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
}

.data-page__table th,
.data-page__table td {
  padding: 0.85rem 1rem;
  text-align: left;
  border-bottom: 1px solid var(--color-border);
}

.data-page__table th {
  color: var(--color-text-muted);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: var(--color-surface);
}

.data-page__table tbody tr:hover {
  background: var(--color-accent-soft);
}

.data-page__cell-truncate {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-page__cell-id {
  max-width: 72px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-page__status {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.data-page__status--sent,
.data-page__status--active,
.data-page__status--completed {
  background: var(--color-accent-soft);
  color: var(--color-accent);
}

.data-page__status--failed,
.data-page__status--full {
  background: var(--color-danger-soft);
  color: var(--color-secondary);
}

.data-page__status--queued,
.data-page__status--scheduled,
.data-page__status--processing,
.data-page__status--partial {
  background: var(--color-accent-soft);
  color: var(--color-accent);
}

.data-page__status--cancelled {
  background: var(--color-muted-soft);
  color: var(--color-text-muted);
}

.data-page__empty {
  padding: 2rem 1rem;
  text-align: center;
  color: var(--color-text-muted);
}

.data-page__table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 1rem;
  border-top: 1px solid var(--color-border);
  color: var(--color-text-muted);
  font-size: 0.82rem;
}

.data-page__pagination {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.data-page__page-btn {
  display: grid;
  place-items: center;
  min-width: 32px;
  height: 32px;
  padding: 0 0.5rem;
  border: none;
  border-radius: 8px;
  background: var(--color-btn);
  color: var(--color-btn-text);
  font-size: 0.82rem;
  cursor: pointer;
  transition: filter 0.2s ease, background 0.2s ease;
}

.data-page__page-btn:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-hover);
}

.data-page__page-btn--active {
  background: var(--color-btn-hover);
  color: var(--color-btn-text);
}

.data-page__page-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.data-page__message {
  margin: 0;
  color: var(--color-accent);
  font-size: 0.88rem;
}

.data-page__actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.data-page__action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: var(--color-btn);
  color: var(--color-btn-text);
  cursor: pointer;
  transition: filter 0.2s ease, background 0.2s ease;
}

.data-page__action-btn svg {
  width: 16px;
  height: 16px;
}

.data-page__action-btn--delete {
  background: var(--color-btn-danger);
  color: var(--color-btn-text);
}

.data-page__action-btn:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-hover);
}

.data-page__action-btn--delete:hover:not(:disabled) {
  background: var(--color-btn-danger-hover);
}

.data-page__action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.data-page__modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: center;
  padding: 1rem;
  background: var(--color-backdrop);
}

.data-page__modal {
  width: min(100%, 420px);
  padding: 1.25rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
}

.data-page__modal--detail {
  width: min(100%, 640px);
  max-height: min(90vh, 720px);
  overflow-y: auto;
}

.data-page__modal--batch-detail {
  width: min(100%, 760px);
  max-height: min(90vh, 720px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 0;
}

.data-page__modal--batch-detail > h3 {
  flex-shrink: 0;
}

.data-page__modal-scroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 0.15rem;
}

.data-page__batch-detail-table-wrap {
  margin-bottom: 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  overflow: auto;
}

.data-page__modal-scroll .data-page__detail-body {
  padding-bottom: 0.5rem;
}

.data-page__modal-footer {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin: 0 -1.25rem;
  padding: 0.85rem 1.25rem;
  border-top: 1px solid var(--color-border);
  background: var(--color-surface-raised);
}

.data-page__modal--import-preview {
  width: min(100%, 760px);
  max-height: min(90vh, 720px);
  display: flex;
  flex-direction: column;
}

.data-page__import-preview-file {
  margin: 0 0 0.75rem;
  color: var(--color-text-muted);
  font-size: 0.88rem;
}

.data-page__import-preview-loading {
  margin: 0 0 1rem;
  color: var(--color-text-muted);
}

.data-page__import-preview-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
  color: var(--color-text-muted);
  font-size: 0.84rem;
}

.data-page__import-preview-valid {
  color: var(--color-accent);
  font-weight: 700;
}

.data-page__import-preview-new {
  color: var(--color-accent);
  font-weight: 700;
}

.data-page__import-preview-exists {
  color: var(--color-warning);
  font-weight: 700;
}

.data-page__import-preview-invalid {
  color: var(--color-secondary);
  font-weight: 700;
}

.data-page__import-preview-verifying {
  color: var(--color-text-muted);
  font-weight: 700;
}

.data-page__import-preview-table-wrap {
  flex: 1 1;
  min-height: 0;
  max-height: 360px;
  overflow: auto;
  margin-bottom: 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
}

.data-page__import-preview-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.84rem;
}

.data-page__import-preview-table th,
.data-page__import-preview-table td {
  padding: 0.65rem 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--color-border);
}

.data-page__import-preview-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--color-surface);
  color: var(--color-text-muted);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.data-page__import-preview-row--invalid {
  background: var(--color-danger-subtle);
}

.data-page__import-preview-row--exists {
  background: var(--color-warning-subtle);
}

.data-page__import-preview-row--success {
  background: var(--color-accent-soft);
}

.data-page__import-preview-row--pending {
  background: transparent;
}

.data-page__import-preview-row--verifying {
  background: var(--color-surface-muted, var(--color-accent-soft));
  outline: 1px solid var(--color-border);
}

.data-page__status--exists {
  background: var(--color-warning-soft);
  color: var(--color-warning);
}

.data-page__status--pending {
  background: var(--color-border);
  color: var(--color-text-muted);
}

.data-page__status--verifying {
  background: var(--color-accent-soft);
  color: var(--color-accent);
}

.data-page__status--failed {
  background: var(--color-danger-subtle);
  color: var(--color-secondary);
}

/* Long SMTP/validation errors in import preview — wrap fully */
.data-page__import-preview-table .data-page__status--failed {
  display: inline-block;
  max-width: min(100%, 22rem);
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-break: break-word;
  line-height: 1.4;
  border-radius: 0.5rem;
  text-transform: none;
  letter-spacing: 0.01em;
  font-weight: 600;
  padding: 0.35rem 0.6rem;
}

.data-page__import-preview-table td:last-child {
  min-width: 12rem;
  max-width: 24rem;
  vertical-align: top;
}

.data-page__import-preview-error {
  display: inline-block;
  max-width: min(100%, 22rem);
  white-space: normal;
  overflow: visible;
  word-break: break-word;
  line-height: 1.4;
  color: var(--color-secondary);
  font-size: 0.8rem;
}

.data-page__detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem 1rem;
}

.data-page__detail-field span {
  display: block;
  margin-bottom: 0.35rem;
  color: var(--color-text-muted);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.data-page__detail-field p {
  margin: 0;
  color: var(--color-text);
  font-size: 0.9rem;
  line-height: 1.45;
  word-break: break-word;
}

.data-page__detail-field--full {
  grid-column: 1 / -1;
}

.data-page__detail-body {
  margin-top: 1rem;
}

.data-page__detail-body span {
  display: block;
  margin-bottom: 0.45rem;
  color: var(--color-text-muted);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.data-page__detail-body pre {
  margin: 0;
  padding: 0.85rem;
  max-height: 220px;
  overflow: auto;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  color: var(--color-text);
  font-family: inherit;
  font-size: 0.84rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.data-page__rdt .rdt_TableRow[data-tag='allowRowEvents'] {
  cursor: pointer;
}

.data-page__modal h3 {
  margin: 0 0 1rem;
  font-size: 1.05rem;
}

.data-page__modal-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 0.85rem;
}

.data-page__modal-field span {
  color: var(--color-text-muted);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.data-page__modal-field input,
.data-page__modal-field select {
  padding: 0.75rem 0.85rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  color: var(--color-text);
  font: inherit;
}

.data-page__modal-field select {
  cursor: pointer;
  appearance: auto;
}

.data-page__password-control {
  position: relative;
}

.data-page__password-control input {
  width: 100%;
  padding-right: 2.75rem;
}

.data-page__toggle-password {
  position: absolute;
  top: 50%;
  right: 0.65rem;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--color-text);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.data-page__toggle-password:hover:not(:disabled) {
  background: var(--color-accent-soft);
}

.data-page__toggle-password:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.data-page__toggle-password svg,
.data-page__toggle-password .app-icon {
  width: 18px;
  height: 18px;
  color: inherit;
}

.data-page__modal-field input:focus,
.data-page__modal-field select:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px var(--color-accent-soft);
}

.data-page__modal-field input[aria-invalid='true'],
.data-page__modal-field select[aria-invalid='true'] {
  border-color: var(--color-secondary);
}

.data-page__field-error {
  margin: 0;
  color: var(--color-secondary);
  font-size: 0.82rem;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
}

.data-page__modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
}

.data-page__modal-btn {
  padding: 0.65rem 0.9rem;
  border: none;
  border-radius: var(--radius);
  background: var(--color-btn);
  color: var(--color-btn-text);
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  transition: filter 0.2s ease, background 0.2s ease;
}

.data-page__modal-btn:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-hover);
}

.data-page__modal-btn--primary {
  background: var(--color-btn);
  color: var(--color-btn-text);
}

.data-page__modal-btn--primary:hover:not(:disabled) {
  background: var(--color-btn-hover);
}

.data-page__modal-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .data-page__header {
    flex-direction: column;
    align-items: stretch;
  }

  .data-page__import-btn {
    justify-content: center;
  }

  .data-page__table th,
  .data-page__table td {
    padding: 0.7rem 0.75rem;
  }

  .data-page__table-footer {
    flex-direction: column;
    align-items: flex-start;
  }

  .data-page__detail-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DataPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,wCAAwC;EACxC,iDAAiD;EACjD,6CAA6C;EAC7C,8CAA8C;EAC9C,6CAA6C;EAC7C,iDAAiD;EACjD,mEAAmE;AACrE;;AAEA;;EAEE,uDAAuD;EACvD,mCAAmC;AACrC;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;;EAEE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;;;;EAIE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,yCAAyC;EACzC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;EAC5B,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gCAAgC;EAChC,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gEAAgE;EAChE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA,+DAA+D;AAC/D;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".data-page__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 0.25rem;\n}\n\n.data-page__intro h2 {\n  margin: 0 0 0.35rem;\n  font-size: clamp(1.6rem, 4vw, 2.2rem);\n  font-weight: 700;\n}\n\n.data-page__subtitle {\n  margin: 0 0 1.5rem;\n  color: var(--color-text-muted);\n  font-size: 0.95rem;\n}\n\n.data-page__intro:has(.data-page__error) .data-page__subtitle,\n.data-page__intro:has(.data-page__message) .data-page__subtitle {\n  margin-bottom: 0.5rem;\n}\n\n.data-page__import-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n  flex-shrink: 0;\n  padding: 0.75rem 1.1rem;\n  border: none;\n  border-radius: var(--radius);\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: filter 0.2s ease, background 0.2s ease;\n}\n\n.data-page__import-btn:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-hover);\n}\n\n.data-page__import-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.data-page__import-btn svg,\n.data-page__bulk-btn svg,\n.data-page__action-btn svg {\n  color: var(--color-icon);\n}\n\n.data-page__import-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.data-page__bulk-btn svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n.data-page__spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: data-page-spin 0.7s linear infinite;\n}\n\n@keyframes data-page-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.data-page__table-section {\n  margin-top: 1.5rem;\n}\n\n.data-page__table-toolbar {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.data-page__search {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  width: 100%;\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  color: var(--color-text);\n  font: inherit;\n}\n\n.data-page__search:focus-within {\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px var(--color-accent-soft);\n}\n\n.data-page__search-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  color: var(--color-text-muted);\n  line-height: 1;\n}\n\n.data-page__search-icon svg,\n.data-page__search-icon .app-icon {\n  width: 18px;\n  height: 18px;\n  color: var(--color-text-muted);\n}\n\n.data-page__search input {\n  flex: 1;\n  min-width: 0;\n  width: auto;\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  color: var(--color-text);\n  font: inherit;\n  line-height: 1.2;\n  outline: none;\n  appearance: none;\n}\n\n.data-page__search input::-webkit-search-decoration,\n.data-page__search input::-webkit-search-cancel-button {\n  appearance: none;\n}\n\n.data-page__search input::placeholder {\n  color: var(--color-text-muted);\n}\n\n.data-page__bulk-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.data-page__feedback {\n  margin-bottom: 0.75rem;\n}\n\n.data-page__error {\n  margin: 0 0 1.5rem;\n  color: var(--color-secondary);\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.data-page__intro .data-page__message {\n  margin: 0 0 1.5rem;\n}\n\n.data-page__bulk-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.55rem 0.9rem;\n  border: none;\n  border-radius: var(--radius);\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: filter 0.2s ease, background 0.2s ease;\n}\n\n.data-page__bulk-btn--delete {\n  background: var(--color-btn-danger);\n  color: var(--color-btn-text);\n}\n\n.data-page__bulk-btn--delete:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-danger-hover);\n}\n\n.data-page__bulk-btn:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-hover);\n}\n\n.data-page__bulk-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.data-page__bulk-btn--import:hover:not(:disabled),\n.data-page__bulk-btn--add:hover:not(:disabled) {\n  color: var(--color-btn-text);\n}\n\n.data-page__modal--confirm h3 {\n  margin-bottom: 0.75rem;\n}\n\n.data-page__confirm-message {\n  margin: 0 0 0.5rem;\n  color: var(--color-text);\n  font-size: 0.95rem;\n}\n\n.data-page__confirm-detail {\n  margin: 0 0 1rem;\n  color: var(--color-text-muted);\n  font-size: 0.88rem;\n}\n\n.data-page__modal-btn--danger {\n  background: var(--color-btn-danger);\n  color: var(--color-btn-text);\n}\n\n.data-page__modal-btn--danger:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-danger-hover);\n}\n\n.data-page__modal-btn--danger:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.data-page__table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n}\n\n.data-page__rdt {\n  --rdt-color-bg: var(--color-surface-raised);\n  --rdt-color-header-bg: var(--color-surface);\n  --rdt-color-text-primary: var(--color-text);\n  --rdt-color-divider: var(--color-border);\n  --rdt-color-highlight: var(--color-rdt-highlight);\n  --rdt-color-highlight-text: var(--color-text);\n  --rdt-color-selected: var(--color-accent-soft);\n  --rdt-color-striped: var(--color-rdt-striped);\n  --rdt-color-btn-hover: var(--color-rdt-btn-hover);\n  --rdt-color-scrollbar-thumb-hover: var(--color-rdt-scrollbar-hover);\n}\n\n.data-page__rdt .rdt_rowHighlight:hover,\n.data-page__rdt .rdt_TableRow:hover {\n  background-color: var(--color-rdt-highlight) !important;\n  color: var(--color-text) !important;\n}\n\n.data-page__rdt .rdt_rowHighlight:hover .rdt_TableCell,\n.data-page__rdt .rdt_rowHighlight:hover .rdt_cell,\n.data-page__rdt .rdt_TableRow:hover .rdt_TableCell {\n  color: var(--color-text) !important;\n}\n\n.data-page__rdt .rdt_Pagination button {\n  color: var(--color-text);\n  fill: var(--color-text);\n}\n\n.data-page__rdt .rdt_Pagination button:disabled {\n  opacity: 0.45;\n}\n\n.data-page__rdt .rdt_Pagination select,\n.data-page__rdt .rdt_Pagination svg {\n  color: var(--color-text-muted);\n  fill: var(--color-text-muted);\n}\n\n.data-page__rdt .rdt_TableCol_Sortable,\n.data-page__rdt .rdt_TableCell {\n  color: var(--color-text);\n}\n\n.data-page__rdt input[type='checkbox'] {\n  accent-color: var(--color-accent);\n  cursor: pointer;\n}\n\n.data-page__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.88rem;\n}\n\n.data-page__table th,\n.data-page__table td {\n  padding: 0.85rem 1rem;\n  text-align: left;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.data-page__table th {\n  color: var(--color-text-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  background: var(--color-surface);\n}\n\n.data-page__table tbody tr:hover {\n  background: var(--color-accent-soft);\n}\n\n.data-page__cell-truncate {\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.data-page__cell-id {\n  max-width: 72px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.data-page__status {\n  display: inline-block;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.data-page__status--sent,\n.data-page__status--active,\n.data-page__status--completed {\n  background: var(--color-accent-soft);\n  color: var(--color-accent);\n}\n\n.data-page__status--failed,\n.data-page__status--full {\n  background: var(--color-danger-soft);\n  color: var(--color-secondary);\n}\n\n.data-page__status--queued,\n.data-page__status--scheduled,\n.data-page__status--processing,\n.data-page__status--partial {\n  background: var(--color-accent-soft);\n  color: var(--color-accent);\n}\n\n.data-page__status--cancelled {\n  background: var(--color-muted-soft);\n  color: var(--color-text-muted);\n}\n\n.data-page__empty {\n  padding: 2rem 1rem;\n  text-align: center;\n  color: var(--color-text-muted);\n}\n\n.data-page__table-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.85rem 1rem;\n  border-top: 1px solid var(--color-border);\n  color: var(--color-text-muted);\n  font-size: 0.82rem;\n}\n\n.data-page__pagination {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.data-page__page-btn {\n  display: grid;\n  place-items: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 0.5rem;\n  border: none;\n  border-radius: 8px;\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n  font-size: 0.82rem;\n  cursor: pointer;\n  transition: filter 0.2s ease, background 0.2s ease;\n}\n\n.data-page__page-btn:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-hover);\n}\n\n.data-page__page-btn--active {\n  background: var(--color-btn-hover);\n  color: var(--color-btn-text);\n}\n\n.data-page__page-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.data-page__message {\n  margin: 0;\n  color: var(--color-accent);\n  font-size: 0.88rem;\n}\n\n.data-page__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.data-page__action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n  cursor: pointer;\n  transition: filter 0.2s ease, background 0.2s ease;\n}\n\n.data-page__action-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.data-page__action-btn--delete {\n  background: var(--color-btn-danger);\n  color: var(--color-btn-text);\n}\n\n.data-page__action-btn:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-hover);\n}\n\n.data-page__action-btn--delete:hover:not(:disabled) {\n  background: var(--color-btn-danger-hover);\n}\n\n.data-page__action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.data-page__modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: grid;\n  place-items: center;\n  padding: 1rem;\n  background: var(--color-backdrop);\n}\n\n.data-page__modal {\n  width: min(100%, 420px);\n  padding: 1.25rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n}\n\n.data-page__modal--detail {\n  width: min(100%, 640px);\n  max-height: min(90vh, 720px);\n  overflow-y: auto;\n}\n\n.data-page__modal--batch-detail {\n  width: min(100%, 760px);\n  max-height: min(90vh, 720px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding-bottom: 0;\n}\n\n.data-page__modal--batch-detail > h3 {\n  flex-shrink: 0;\n}\n\n.data-page__modal-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding-right: 0.15rem;\n}\n\n.data-page__batch-detail-table-wrap {\n  margin-bottom: 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  overflow: auto;\n}\n\n.data-page__modal-scroll .data-page__detail-body {\n  padding-bottom: 0.5rem;\n}\n\n.data-page__modal-footer {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin: 0 -1.25rem;\n  padding: 0.85rem 1.25rem;\n  border-top: 1px solid var(--color-border);\n  background: var(--color-surface-raised);\n}\n\n.data-page__modal--import-preview {\n  width: min(100%, 760px);\n  max-height: min(90vh, 720px);\n  display: flex;\n  flex-direction: column;\n}\n\n.data-page__import-preview-file {\n  margin: 0 0 0.75rem;\n  color: var(--color-text-muted);\n  font-size: 0.88rem;\n}\n\n.data-page__import-preview-loading {\n  margin: 0 0 1rem;\n  color: var(--color-text-muted);\n}\n\n.data-page__import-preview-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n  color: var(--color-text-muted);\n  font-size: 0.84rem;\n}\n\n.data-page__import-preview-valid {\n  color: var(--color-accent);\n  font-weight: 700;\n}\n\n.data-page__import-preview-new {\n  color: var(--color-accent);\n  font-weight: 700;\n}\n\n.data-page__import-preview-exists {\n  color: var(--color-warning);\n  font-weight: 700;\n}\n\n.data-page__import-preview-invalid {\n  color: var(--color-secondary);\n  font-weight: 700;\n}\n\n.data-page__import-preview-verifying {\n  color: var(--color-text-muted);\n  font-weight: 700;\n}\n\n.data-page__import-preview-table-wrap {\n  flex: 1;\n  min-height: 0;\n  max-height: 360px;\n  overflow: auto;\n  margin-bottom: 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n}\n\n.data-page__import-preview-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.84rem;\n}\n\n.data-page__import-preview-table th,\n.data-page__import-preview-table td {\n  padding: 0.65rem 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.data-page__import-preview-table th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: var(--color-surface);\n  color: var(--color-text-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.data-page__import-preview-row--invalid {\n  background: var(--color-danger-subtle);\n}\n\n.data-page__import-preview-row--exists {\n  background: var(--color-warning-subtle);\n}\n\n.data-page__import-preview-row--success {\n  background: var(--color-accent-soft);\n}\n\n.data-page__import-preview-row--pending {\n  background: transparent;\n}\n\n.data-page__import-preview-row--verifying {\n  background: var(--color-surface-muted, var(--color-accent-soft));\n  outline: 1px solid var(--color-border);\n}\n\n.data-page__status--exists {\n  background: var(--color-warning-soft);\n  color: var(--color-warning);\n}\n\n.data-page__status--pending {\n  background: var(--color-border);\n  color: var(--color-text-muted);\n}\n\n.data-page__status--verifying {\n  background: var(--color-accent-soft);\n  color: var(--color-accent);\n}\n\n.data-page__status--failed {\n  background: var(--color-danger-subtle);\n  color: var(--color-secondary);\n}\n\n/* Long SMTP/validation errors in import preview — wrap fully */\n.data-page__import-preview-table .data-page__status--failed {\n  display: inline-block;\n  max-width: min(100%, 22rem);\n  white-space: normal;\n  overflow: visible;\n  text-overflow: unset;\n  word-break: break-word;\n  line-height: 1.4;\n  border-radius: 0.5rem;\n  text-transform: none;\n  letter-spacing: 0.01em;\n  font-weight: 600;\n  padding: 0.35rem 0.6rem;\n}\n\n.data-page__import-preview-table td:last-child {\n  min-width: 12rem;\n  max-width: 24rem;\n  vertical-align: top;\n}\n\n.data-page__import-preview-error {\n  display: inline-block;\n  max-width: min(100%, 22rem);\n  white-space: normal;\n  overflow: visible;\n  word-break: break-word;\n  line-height: 1.4;\n  color: var(--color-secondary);\n  font-size: 0.8rem;\n}\n\n.data-page__detail-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.85rem 1rem;\n}\n\n.data-page__detail-field span {\n  display: block;\n  margin-bottom: 0.35rem;\n  color: var(--color-text-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.data-page__detail-field p {\n  margin: 0;\n  color: var(--color-text);\n  font-size: 0.9rem;\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n.data-page__detail-field--full {\n  grid-column: 1 / -1;\n}\n\n.data-page__detail-body {\n  margin-top: 1rem;\n}\n\n.data-page__detail-body span {\n  display: block;\n  margin-bottom: 0.45rem;\n  color: var(--color-text-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.data-page__detail-body pre {\n  margin: 0;\n  padding: 0.85rem;\n  max-height: 220px;\n  overflow: auto;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  color: var(--color-text);\n  font-family: inherit;\n  font-size: 0.84rem;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.data-page__rdt .rdt_TableRow[data-tag='allowRowEvents'] {\n  cursor: pointer;\n}\n\n.data-page__modal h3 {\n  margin: 0 0 1rem;\n  font-size: 1.05rem;\n}\n\n.data-page__modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-bottom: 0.85rem;\n}\n\n.data-page__modal-field span {\n  color: var(--color-text-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.data-page__modal-field input,\n.data-page__modal-field select {\n  padding: 0.75rem 0.85rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  color: var(--color-text);\n  font: inherit;\n}\n\n.data-page__modal-field select {\n  cursor: pointer;\n  appearance: auto;\n}\n\n.data-page__password-control {\n  position: relative;\n}\n\n.data-page__password-control input {\n  width: 100%;\n  padding-right: 2.75rem;\n}\n\n.data-page__toggle-password {\n  position: absolute;\n  top: 50%;\n  right: 0.65rem;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--color-text);\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.data-page__toggle-password:hover:not(:disabled) {\n  background: var(--color-accent-soft);\n}\n\n.data-page__toggle-password:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.data-page__toggle-password svg,\n.data-page__toggle-password .app-icon {\n  width: 18px;\n  height: 18px;\n  color: inherit;\n}\n\n.data-page__modal-field input:focus,\n.data-page__modal-field select:focus {\n  outline: none;\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px var(--color-accent-soft);\n}\n\n.data-page__modal-field input[aria-invalid='true'],\n.data-page__modal-field select[aria-invalid='true'] {\n  border-color: var(--color-secondary);\n}\n\n.data-page__field-error {\n  margin: 0;\n  color: var(--color-secondary);\n  font-size: 0.82rem;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n.data-page__modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n.data-page__modal-btn {\n  padding: 0.65rem 0.9rem;\n  border: none;\n  border-radius: var(--radius);\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n  font-size: 0.82rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: filter 0.2s ease, background 0.2s ease;\n}\n\n.data-page__modal-btn:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-hover);\n}\n\n.data-page__modal-btn--primary {\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n}\n\n.data-page__modal-btn--primary:hover:not(:disabled) {\n  background: var(--color-btn-hover);\n}\n\n.data-page__modal-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .data-page__header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .data-page__import-btn {\n    justify-content: center;\n  }\n\n  .data-page__table th,\n  .data-page__table td {\n    padding: 0.7rem 0.75rem;\n  }\n\n  .data-page__table-footer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .data-page__detail-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
